import {useContext} from "react";
import {TextNode} from "./CmsTypes";
import {TextContentContext} from "./TextSection";
import {renderVariables} from "./cmsHelpers";
import {TextBlock} from "@/shared/strapiTypes/common/Blocks";

const TextNodeComponent: React.FC<{node: TextNode | TextBlock}> = ({node}) => {
	const {variables = {}} = useContext(TextContentContext);
	const text = renderVariables(node.text, variables);
	const classes = [];
	if (node.bold) {
		classes.push("font-bold");
	}
	if (node.italic) {
		classes.push("italic");
	}
	if (node.underline) {
		classes.push("underline");
	}
	if (node.strikethrough) {
		classes.push("line-through");
	}
	if (node.code) {
		// Doesn't do anything yet
		classes.push("font-mono");
	}
	return <span className={classes.join(" ")}>{text}</span>;
};

export default TextNodeComponent;
